import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context";
import { Select } from "antd";
import { FIELD_WIDTHS } from "../../config/layoutConfig";

function AHPSelect({
  label,
  type,
  field,
  options,
  width,
  allowClear,
  disabled,
  onChange,
}) {
  const info = useContext(AppContext);

  const handleChange = (type, field, value) => {
    // info[type][field] = value;
    info.setService(type, info[type], field, value);
  };

  return (
    options?.length > 0 && (
      <Select
        placeholder={label}
        options={options}
        bordered={false}
        allowClear={allowClear}
        value={info[type][field]}
        style={{ width: width || FIELD_WIDTHS.M, marginRight: 20 }}
        onChange={(value) => {
          if (onChange) onChange(value);
          handleChange(type, field, value);
        }}
        disabled={disabled}
      ></Select>
    )
  );
}

export default AHPSelect;
